import { TabularCopySink } from './tabular.copysink';
import { Metamodel } from 'app/model/base/model';
import { IAttribute, IModel } from 'app/model/base/annotation';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { PostgreSqlV2Dataset } from 'app/model/dataset/postgre-sql-v2.dataset';

@Metamodel.model({
    name: adfModelTypeMap.postgreSql.copySinkType,
    display: [],
    referable: true,
    tags: { datasetModel: [Metamodel.modelFor(PostgreSqlV2Dataset)] }
})
export class PostgreSqlV2Sink extends TabularCopySink {
    public static readonly MODEL: IModel;
     public static readonly WRITE_BEHAVIOR: IAttribute;
    constructor(name?: string, description?: string, id?: number) {
        super(name, description, id);
        this.writeBatchSize = 50000;
        this.writeBatchTimeout = '00:02:00';
    }

    @Metamodel.attribute({
        templatable: true,
        association: 'WRITE_BEHAVIOR',
        display: stringResources.ModelName_WriteBehavior
    })
    public writeBehavior: 'insert' | 'upsert' = 'insert';
}
